import LegalPage from "../Legal/LegalPage";

// Public page required for Google OAuth brand verification. Generic by design.
const TermsOfService = () => {
	return (
		<LegalPage pill="Terms" title="Terms of Service" effective="21 September 2026">
			<p>
				These terms govern use of Rarebox, an internal business application operated by Radhamani Textiles Pvt.
				Ltd., trading as The House of Rare (&quot;we&quot;, &quot;us&quot;). By signing in to Rarebox you agree
				to these terms.
			</p>

			<h2>1. Authorised use only</h2>
			<p>
				Rarebox is a private system for our employees and authorised contractors. Accounts are issued by us,
				are personal to the individual they are issued to, and must not be shared. There is no public
				registration.
			</p>

			<h2>2. Acceptable use</h2>
			<ul>
				<li>Use Rarebox only for your work for us.</li>
				<li>Do not access data or features you have not been granted permission to use.</li>
				<li>Do not copy or disclose business information outside the organisation without authorisation.</li>
				<li>Do not interfere with, probe or attempt to disrupt the application.</li>
			</ul>

			<h2>3. Third-party services</h2>
			<p>
				Some features rely on Google services and are additionally subject to{" "}
				<a href="https://developers.google.com/terms" rel="noopener noreferrer" target="_blank">
					Google&apos;s terms
				</a>
				. Outputs produced with the help of these services are for internal review and decision-making only.
			</p>

			<h2>4. Confidentiality and ownership</h2>
			<p>
				Rarebox and all business information within it belong to us and are confidential. These terms grant
				users no ownership rights, and confidentiality obligations continue after access ends.
			</p>

			<h2>5. Availability and liability</h2>
			<p>
				Rarebox is provided &quot;as is&quot;. We may change, suspend or withdraw it, or any user&apos;s access,
				at any time without notice. To the extent permitted by law, we are not liable for any indirect or
				consequential loss arising from its use.
			</p>

			<h2>6. Termination</h2>
			<p>Access ends when your engagement with us ends, or if these terms are breached.</p>

			<h2>7. Privacy</h2>
			<p>
				Our handling of data is described in our <a href="/privacy-policy">Privacy Policy</a>, which forms part
				of these terms.
			</p>

			<h2>8. Governing law</h2>
			<p>These terms are governed by the laws of India. The courts at Bangalore have exclusive jurisdiction.</p>

			<h2>9. Contact</h2>
			<p>
				<a href="mailto:support@thehouseofrare.com">support@thehouseofrare.com</a>
			</p>
		</LegalPage>
	);
};

export default TermsOfService;
